import { push } from "connected-react-router";

import { getQuestionsList, changeQuestionVisibility, sortQuestions } from '../../request'; 
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { clearQuestionForm } from "./editQuestion";
import { showErrorMessage, hideErrorMessage, showSuccessMessage } from "./ui";

//Загрузка списка вопросов
export const QUESTIONS_LOADING_START = "Questions list loading start";
export const QUESTIONS_LOADING_SUCCESS = "Questions list loading success";
export const QUESTIONS_LOADING_FAILED = "Failure during questions list load";

//Восстановление вопроса
export const QUESTION_RESTORE_START = "Question restore start";
export const QUESTION_RESTORED_SUCCESSFULLY = "Question restored successfully";
export const QUESTION_RESTORE_FAILED = "Failure during question restore";

//Перемещение вопроса по списку
export const QUESTIONS_SORTING_START = "Questions sorting start";
export const QUESTIONS_SORTED_SUCCESSFULLY = "Questions sorted successfully";
export const QUESTIONS_SORTING_FAILED = "Questions sorting failed";

//Фильтры
export const SWITCH_QUESTIONS_FILTER = "Switch questions filter";

//Пагинация
export const CHANGE_QUESTIONS_PAGE = "Change questions page";
export const CHANGE_QUESTIONS_LIMIT = "Change questions limit";

const startLoading = () => ({
  type: QUESTIONS_LOADING_START
});

const loadSuccess = questions => ({
  type: QUESTIONS_LOADING_SUCCESS,
  payload: {
    questions: questions || []
  }
});

const loadFailure = () => ({
  type: QUESTIONS_LOADING_FAILED,
});


//Загрузка списка вопросов
export const getQuestionsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let questions;
    try {
      const accessToken = localStorage.getItem("accessToken");
      questions = await getQuestionsList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка вопросов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(questions));
  };
};

export const goToQuestionCreation = () => {
  return async (dispatch) => {
    dispatch(clearQuestionForm());
    dispatch(push('/create-question'));
  };
};

//Фильтры
export const switchQuestionsFilter = tab => ({
  type: SWITCH_QUESTIONS_FILTER,
  payload: { tab }
});

//ВОССТАНОВЛЕНИЕ ВОПРОСА
const startRestore = () => ({
  type: QUESTION_RESTORE_START
});

const restoreSuccess = (status, questionIndex) => ({
  type: QUESTION_RESTORED_SUCCESSFULLY,
  payload: { status, questionIndex },
});

const restoreFailure = () => ({
  type: QUESTION_RESTORE_FAILED,
});

export const restoreQuestionAsync = (status, questionId, questionIndex) => { 
  return async (dispatch) => {
    dispatch(startRestore());
    await dispatch(checkAndRenewTokens());
    const data = { is_visible: status };
    try {
      const accessToken = localStorage.getItem("accessToken");
      await changeQuestionVisibility(accessToken, data, questionId);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при восстановлении вопроса!"));
      dispatch(checkTokenError(err));
      return dispatch(restoreFailure());
    }
    dispatch(showSuccessMessage('Вопрос восстановлен!'));
    return dispatch(restoreSuccess(status, questionIndex));
  };
};

//ПЕРЕМЕЩЕНИЕ ВОПРОСА ПО СПИСКУ ВОПРОСОВ
const startSorting = () => ({
  type: QUESTIONS_SORTING_START
});

const sortingSuccess = () => ({
  type: QUESTIONS_SORTED_SUCCESSFULLY,
});

const sortingFailure = () => ({
  type: QUESTIONS_SORTING_FAILED,
});

export const sortQuestionsAsync = ({oldIndex, newIndex}) => {
  return async (dispatch, getState) => {
    dispatch(startSorting());
    await dispatch(checkAndRenewTokens());

    //Сформируем массив IDs
    const currentState = getState();
    const questionsList = currentState.questionsList.questions;
    const idsArr = questionsList.map((question, i) => { return question.id });
    //Отсортируем массив
    const itemId = idsArr.splice(oldIndex, 1);
    idsArr.splice(newIndex, 0, itemId[0]);
    const data = { order_data: idsArr };

    try {
      const accessToken = localStorage.getItem("accessToken");
      await sortQuestions(accessToken, data);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при сортировке вопросов"));
      dispatch(checkTokenError(err));
      return dispatch(sortingFailure());
    }
    return dispatch(sortingSuccess());
  };
};

//Пагинация на вкладке Архив списка вопросов 
export const changeQuestionsPage = activePage => ({
  type: CHANGE_QUESTIONS_PAGE,
  payload: { activePage }
});

//Отображение элементов на вкладке Архив списка вопросов 
export const changeQuestionsLimit = activeLimit => ({
  type: CHANGE_QUESTIONS_LIMIT,
  payload: { activeLimit }
});